export const FORM_FIELDS = {
   SOURCE_CODE: 'sourceCodeTextarea',
} as const;